// import React, { useState, useEffect, useRef } from "react";
// import { BASE_URL, DOMAIN_URL } from "../../config";

// const BlogArchive = ({ onNavigate }) => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isAnimating, setIsAnimating] = useState(false);
//   const [openPostMenus, setOpenPostMenus] = useState({});
//   const [archivedPosts, setArchivedPosts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [totalBlogs, setTotalBlogs] = useState(0);
//   const menuRef = useRef(null);
//   const urlParams = new URLSearchParams(window.location.search);
//   const token = urlParams.get("token");
//   // Pagination state
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 5;

//   // Calculate pagination
//   const totalPages = Math.ceil(totalBlogs / itemsPerPage);

//   useEffect(() => {
//     const urlParams = new URLSearchParams(window.location.search);
//     const urlToken = urlParams.get("token");

//     if (urlToken) {
//       localStorage.setItem("authToken", urlToken);
//       // Clean up URL
//     }
//   }, []);

//   // Update your fetchArchivedBlogs function with more debugging
//   const fetchArchivedBlogs = async (page = 1, limit = 5) => {
//     try {
//       setLoading(true);
//       setError(null);

//       // Fix: Ensure page and limit are numbers
//       const pageNum = Number(page) || 1;
//       const limitNum = Number(limit) || 5;

//       console.log("=== ARCHIVE DEBUG ===");
//       console.log("Fetching archived blogs with params:", {
//         page: pageNum,
//         limit: limitNum,
//       });
//       console.log("Token exists:", !!token);
//       console.log("Token value:", token); // Add this to see the actual token
//       console.log(
//         "API URL:",
//         `${BASE_URL}/blogs/archived?page=${pageNum}&limit=${limitNum}`
//       );

//       const response = await fetch(
//         `${BASE_URL}/blogs/archived?page=${pageNum}&limit=${limitNum}`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       console.log("Archive API response status:", response.status);

//       if (response.ok) {
//         const result = await response.json();
//         console.log("Archive API full response:", result);

//         setArchivedPosts(result.blogs || []);
//         setTotalBlogs(result.total || 0);
//       } else {
//         const errorText = await response.text();
//         console.error("Archive API error response:", errorText);
//         setError("Failed to fetch archived blogs: " + errorText);
//       }
//     } catch (error) {
//       console.error("Archive fetch error:", error);
//       setError("Error fetching archived blogs: " + error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Load archived blogs on component mount
//   useEffect(() => {
//     if (token) {
//       fetchArchivedBlogs(currentPage, itemsPerPage);
//     }
//   }, [currentPage, token]);

//   // Close menu when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (menuRef.current && !menuRef.current.contains(event.target)) {
//         setIsMenuOpen(false);
//       }
//       if (!event.target.closest(".post-menu")) {
//         setOpenPostMenus({});
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   // Handle navigation with animation
//   const handleNavigation = (view) => {
//     setIsAnimating(true);
//     setIsMenuOpen(false);
//     setTimeout(() => {
//       onNavigate(view);
//       setIsAnimating(false);
//     }, 150);
//   };

//   // Handle post menu toggle
//   const togglePostMenu = (postId) => {
//     setOpenPostMenus((prev) => ({
//       ...prev,
//       [postId]: !prev[postId],
//     }));
//   };

//   // Handle restore action
//   const handlePostAction = async (action, postId) => {
//     console.log(`${action} post:`, postId);
//     setOpenPostMenus({});

//     if (action === "restore-to-active") {
//       // Show confirmation dialog
//       const confirmed = window.confirm(
//         "Are you sure you want to restore this blog post?"
//       );

//       if (!confirmed) {
//         return;
//       }

//       try {
//         console.log("Attempting to restore archived blog:", postId);

//         const response = await fetch(`${BASE_URL}/blogs/${postId}/unarchive`, {
//           method: "PATCH",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         console.log("Restore response status:", response.status);

//         if (response.ok) {
//           const result = await response.json();
//           console.log("Blog restored successfully:", result);

//           // Refresh the archived blogs list
//           await fetchArchivedBlogs(currentPage, itemsPerPage);

//           alert("Blog post restored successfully!");
//         } else {
//           const errorData = await response.json();
//           console.error("Failed to restore blog post:", errorData);
//           alert("Failed to restore blog post: " + errorData.message);
//         }
//       } catch (error) {
//         console.error("Error restoring blog post:", error);
//         alert("Error restoring blog post: " + error.message);
//       }
//     }
//   };

//   // Pagination handlers
//   const goToPage = (page) => {
//     setCurrentPage(page);
//   };

//   const goToPrevious = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };

//   const goToNext = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//     }
//   };

//   // Format date
//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     return date.toLocaleDateString("en-US", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//     });
//   };

//   return (
//     <div className="h-screen flex flex-col bg-gray-50">
//       {/* Fixed Header */}
//       <div className="flex-shrink-0 bg-white shadow-sm border-b">
//         <div className="px-4 py-4">
//           <div className="flex items-center justify-between">
//             {/* Navigation Menu */}
//             <div className="relative" ref={menuRef}>
//               <button
//                 onClick={() => setIsMenuOpen(!isMenuOpen)}
//                 className="p-2 hover:bg-gray-100 rounded transition-colors"
//               >
//                 <svg
//                   className="w-6 h-6"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M4 6h16M4 12h16M4 18h16"
//                   />
//                 </svg>
//               </button>

//               {/* Navigation Menu */}
//               {isMenuOpen && (
//                 <div className="absolute top-full left-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-50 overflow-hidden">
//                   <div className="py-2">
//                     <button
//                       onClick={() => handleNavigation("home")}
//                       className="w-full text-left px-4 py-3 hover:bg-gray-50 transition-colors flex items-center text-gray-700"
//                     >
//                       <svg
//                         className="w-4 h-4 mr-3"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z"
//                         />
//                       </svg>
//                       Home
//                     </button>

//                     <button
//                       onClick={() => handleNavigation("delete")}
//                       className="w-full text-left px-4 py-3 hover:bg-gray-50 transition-colors flex items-center text-gray-700"
//                     >
//                       <svg
//                         className="w-4 h-4 mr-3"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
//                         />
//                       </svg>
//                       Delete
//                     </button>

//                     <button className="w-full text-left px-4 py-3 hover:bg-gray-50 transition-colors flex items-center bg-yellow-50 text-yellow-600 border-r-2 border-yellow-600">
//                       <svg
//                         className="w-4 h-4 mr-3"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h14a2 2 0 002-2V8m-9 4h4"
//                         />
//                       </svg>
//                       Archive
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>

//             {/* Action Buttons */}
//             <div className="flex gap-4">
//               <span className="px-4 py-2 bg-yellow-100 text-yellow-700 rounded font-medium">
//                 Archived Posts Management
//               </span>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Scrollable Content Area */}
//       <div className="flex-1 overflow-auto">
//         <div
//           className={`px-4 py-6 transition-all duration-300 ${
//             isAnimating
//               ? "opacity-50 transform translate-x-4"
//               : "opacity-100 transform translate-x-0"
//           }`}
//         >
//           {/* Page Info */}
//           <div className="mb-6 flex justify-between items-center">
//             <h2 className="text-xl font-semibold text-gray-800">
//               Archived Posts (Page {currentPage} of {totalPages || 1})
//             </h2>
//             <p className="text-gray-600">{totalBlogs} total archived blogs</p>
//           </div>

//           {/* Loading State */}
//           {loading && (
//             <div className="flex justify-center items-center py-16">
//               <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-yellow-500"></div>
//               <span className="ml-2 text-gray-600">
//                 Loading archived posts...
//               </span>
//             </div>
//           )}

//           {/* Error State */}
//           {error && (
//             <div className="flex flex-col items-center justify-center py-16">
//               <div className="text-red-500 text-center mb-4">
//                 <svg
//                   className="w-16 h-16 mx-auto mb-2"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.728-.833-2.498 0L4.316 16.5c-.77.833.192 2.5 1.732 2.5z"
//                   />
//                 </svg>
//                 <p className="text-lg font-semibold">
//                   Error loading archived posts
//                 </p>
//                 <p className="text-sm">{error}</p>
//               </div>
//               <button
//                 onClick={() => fetchArchivedBlogs(currentPage, itemsPerPage)}
//                 className="px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600"
//               >
//                 Retry
//               </button>
//             </div>
//           )}

//           {/* Empty State */}
//           {!loading && !error && archivedPosts.length === 0 && (
//             <div className="flex flex-col items-center justify-center py-16">
//               <div className="text-6xl mb-4">📦</div>
//               <h3 className="text-xl font-semibold text-gray-800 mb-2">
//                 No archived posts found
//               </h3>
//               <p className="text-gray-600">No archived posts to show.</p>
//             </div>
//           )}

//           {/* Blog Posts Grid */}
//           {!loading && !error && archivedPosts.length > 0 && (
//             <>
//               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-8">
//                 {archivedPosts.map((post) => (
//                   <div
//                     key={post.blog_id}
//                     className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow cursor-pointer opacity-75 border-2 border-yellow-200 relative"
//                   >
//                     {/* ARCHIVED Badge */}
//                     <div className="p-2 bg-yellow-50 border-b border-yellow-100">
//                       <span className="text-xs text-yellow-600 font-medium">
//                         ARCHIVED
//                       </span>
//                     </div>

//                     {/* Top-Right Post Menu Button */}
//                     <div className="absolute top-12 right-3 z-10 post-menu">
//                       <button
//                         onClick={() => togglePostMenu(post.blog_id)}
//                         className="p-2 bg-white/95 hover:bg-white rounded-lg shadow-md transition-colors border border-gray-200"
//                       >
//                         <svg
//                           className="w-4 h-4"
//                           fill="none"
//                           stroke="currentColor"
//                           viewBox="0 0 24 24"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth={2}
//                             d="M4 6h16M4 12h16M4 18h16"
//                           />
//                         </svg>
//                       </button>

//                       {/* Post Menu Dropdown */}
//                       {openPostMenus[post.blog_id] && (
//                         <div className="absolute top-full right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-50 overflow-hidden">
//                           <div className="py-2">
//                             <button
//                               onClick={() =>
//                                 handlePostAction(
//                                   "restore-to-active",
//                                   post.blog_id
//                                 )
//                               }
//                               className="w-full text-left px-4 py-2 hover:bg-blue-50 transition-colors flex items-center text-blue-600"
//                             >
//                               <svg
//                                 className="w-4 h-4 mr-3"
//                                 fill="none"
//                                 stroke="currentColor"
//                                 viewBox="0 0 24 24"
//                               >
//                                 <path
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                   strokeWidth={2}
//                                   d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
//                                 />
//                               </svg>
//                               Restore
//                             </button>
//                           </div>
//                         </div>
//                       )}
//                     </div>

//                     {/* Card Image */}
//                     <div className="h-50 bg-gradient-to-br from-purple-100 to-purple-200 flex items-center justify-center">
//                       {post.main_image_url ? (
//                         <img
//                           src={post.main_image_url}
//                           alt={post.title}
//                           className="w-full h-[300px] min-h[300px] object-cover"
//                         />
//                       ) : (
//                         <div className="w-16 h-16 bg-yellow-400 rounded-full flex items-center justify-center">
//                           <svg
//                             className="w-8 h-8 text-white"
//                             fill="currentColor"
//                             viewBox="0 0 20 20"
//                           >
//                             <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
//                           </svg>
//                         </div>
//                       )}
//                     </div>

//                     {/* Card Content */}
//                     <div className="p-4">
//                       <div className="flex justify-between items-start text-xs text-gray-600 mb-2">
//                         <span>{post.status}</span>
//                         <span>{formatDate(post.created_at)}</span>
//                       </div>
//                       <h3 className="font-semibold text-gray-800 mb-3 text-sm text-center">
//                         {post.title}
//                       </h3>
//                       {post.tags && post.tags.length > 0 && (
//                         <div className="flex flex-wrap gap-1 mt-2">
//                           {post.tags.slice(0, 3).map((tag, index) => (
//                             <span
//                               key={index}
//                               className="px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded"
//                             >
//                               {tag}
//                             </span>
//                           ))}
//                           {post.tags.length > 3 && (
//                             <span className="text-xs text-gray-500">
//                               +{post.tags.length - 3} more
//                             </span>
//                           )}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 ))}
//               </div>

//               {/* Pagination */}
//               {totalPages > 1 && (
//                 <div className="flex justify-center items-center gap-4 pb-16">
//                   <button
//                     onClick={goToPrevious}
//                     disabled={currentPage === 1}
//                     className="px-4 py-2 bg-white border border-gray-300 rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
//                   >
//                     Previous
//                   </button>

//                   <div className="flex gap-2">
//                     {Array.from({ length: totalPages }, (_, i) => i + 1).map(
//                       (page) => (
//                         <button
//                           key={page}
//                           onClick={() => goToPage(page)}
//                           className={`px-3 py-2 border rounded ${
//                             currentPage === page
//                               ? "bg-yellow-500 text-white border-yellow-500"
//                               : "bg-white border-gray-300 hover:bg-gray-50"
//                           }`}
//                         >
//                           {page}
//                         </button>
//                       )
//                     )}
//                   </div>

//                   <button
//                     onClick={goToNext}
//                     disabled={currentPage === totalPages}
//                     className="px-4 py-2 bg-white border border-gray-300 rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
//                   >
//                     Next
//                   </button>
//                 </div>
//               )}
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BlogArchive;


import React, { useState, useEffect, useRef } from "react";
import { BASE_URL, DOMAIN_URL } from "../../config";

const BlogArchive = ({ onNavigate }) => {

  const [isAnimating, setIsAnimating] = useState(false);
  const [openPostMenus, setOpenPostMenus] = useState({});
  const [archivedPosts, setArchivedPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalBlogs, setTotalBlogs] = useState(0);

  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("token");
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Calculate pagination
  const totalPages = Math.ceil(totalBlogs / itemsPerPage);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlToken = urlParams.get("token");

    if (urlToken) {
      localStorage.setItem("authToken", urlToken);
      // Clean up URL
    }
  }, []);

  // Update your fetchArchivedBlogs function with more debugging
  const fetchArchivedBlogs = async (page = 1, limit = 5) => {
    try {
      setLoading(true);
      setError(null);

      // Fix: Ensure page and limit are numbers
      const pageNum = Number(page) || 1;
      const limitNum = Number(limit) || 5;

      console.log("=== ARCHIVE DEBUG ===");
      console.log("Fetching archived blogs with params:", {
        page: pageNum,
        limit: limitNum,
      });
      console.log("Token exists:", !!token);
      console.log("Token value:", token); // Add this to see the actual token
      console.log(
        "API URL:",
        `${BASE_URL}/blogs/archived?page=${pageNum}&limit=${limitNum}`
      );

      const response = await fetch(
        `${BASE_URL}/blogs/archived?page=${pageNum}&limit=${limitNum}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Archive API response status:", response.status);

      if (response.ok) {
        const result = await response.json();
        console.log("Archive API full response:", result);

        setArchivedPosts(result.blogs || []);
        setTotalBlogs(result.total || 0);
      } else {
        const errorText = await response.text();
        console.error("Archive API error response:", errorText);
        setError("Failed to fetch archived blogs: " + errorText);
      }
    } catch (error) {
      console.error("Archive fetch error:", error);
      setError("Error fetching archived blogs: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  // Load archived blogs on component mount
  useEffect(() => {
    if (token) {
      fetchArchivedBlogs(currentPage, itemsPerPage);
    }
  }, [currentPage, token]);

  // Close menu when clicking outside
// Keep only the post menu part:
useEffect(() => {
  const handleClickOutside = (event) => {
    if (!event.target.closest(".post-menu")) {
      setOpenPostMenus({});
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);

  // Handle navigation with animation
  const handleNavigation = (view) => {
    setIsAnimating(true);

    setTimeout(() => {
      onNavigate(view);
      setIsAnimating(false);
    }, 150);
  };

  // Handle post menu toggle
  const togglePostMenu = (postId) => {
    setOpenPostMenus((prev) => ({
      ...prev,
      [postId]: !prev[postId],
    }));
  };

  // Handle restore action
  const handlePostAction = async (action, postId) => {
    console.log(`${action} post:`, postId);
    setOpenPostMenus({});

    if (action === "restore-to-active") {
      // Show confirmation dialog
      const confirmed = window.confirm(
        "Are you sure you want to restore this blog post?"
      );

      if (!confirmed) {
        return;
      }

      try {
        console.log("Attempting to restore archived blog:", postId);

        const response = await fetch(`${BASE_URL}/blogs/${postId}/unarchive`, {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        console.log("Restore response status:", response.status);

        if (response.ok) {
          const result = await response.json();
          console.log("Blog restored successfully:", result);

          // Refresh the archived blogs list
          await fetchArchivedBlogs(currentPage, itemsPerPage);

          alert("Blog post restored successfully!");
        } else {
          const errorData = await response.json();
          console.error("Failed to restore blog post:", errorData);
          alert("Failed to restore blog post: " + errorData.message);
        }
      } catch (error) {
        console.error("Error restoring blog post:", error);
        alert("Error restoring blog post: " + error.message);
      }
    }
  };

  // Pagination handlers
  const goToPage = (page) => {
    setCurrentPage(page);
  };

  const goToPrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  return (
    <div className="h-screen flex flex-col bg-gray-50">
      {/* Fixed Header */}
      <div className="flex-shrink-0 bg-white shadow-sm border-b">
        <div className="px-4 py-4">
          <div className="flex items-center justify-between">
            {/* Navigation Menu */}
          {/* Tab Navigation */}
<div className="flex bg-gray-100 rounded-lg p-1">
  <button
    onClick={() => handleNavigation("home")}
    className="px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 text-gray-600 hover:text-gray-800"
  >
    <svg
      className="w-4 h-4 inline mr-2"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z"
      />
    </svg>
    Home
  </button>

  <button
    onClick={() => handleNavigation("delete")}
    className="px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 text-gray-600 hover:text-gray-800"
  >
    <svg
      className="w-4 h-4 inline mr-2"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
      />
    </svg>
    Deleted
  </button>

  <button className="px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 bg-white text-yellow-600 shadow-sm">
    <svg
      className="w-4 h-4 inline mr-2"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h14a2 2 0 002-2V8m-9 4h4"
      />
    </svg>
    Archive
  </button>
</div>

            {/* Action Buttons */}
            <div className="flex gap-4">
              <span className="px-4 py-2 bg-yellow-100 text-yellow-700 rounded font-medium">
                Archived Posts Management
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Scrollable Content Area */}
      <div className="flex-1 overflow-auto">
        <div
          className={`px-4 py-6 transition-all duration-300 ${
            isAnimating
              ? "opacity-50 transform translate-x-4"
              : "opacity-100 transform translate-x-0"
          }`}
        >
          {/* Page Info */}
          <div className="mb-6 flex justify-between items-center">
            <h2 className="text-xl font-semibold text-gray-800">
              Archived Posts (Page {currentPage} of {totalPages || 1})
            </h2>
            <p className="text-gray-600">{totalBlogs} total archived blogs</p>
          </div>

          {/* Loading State */}
          {loading && (
            <div className="flex justify-center items-center py-16">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-yellow-500"></div>
              <span className="ml-2 text-gray-600">
                Loading archived posts...
              </span>
            </div>
          )}

          {/* Error State */}
          {error && (
            <div className="flex flex-col items-center justify-center py-16">
              <div className="text-red-500 text-center mb-4">
                <svg
                  className="w-16 h-16 mx-auto mb-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.728-.833-2.498 0L4.316 16.5c-.77.833.192 2.5 1.732 2.5z"
                  />
                </svg>
                <p className="text-lg font-semibold">
                  Error loading archived posts
                </p>
                <p className="text-sm">{error}</p>
              </div>
              <button
                onClick={() => fetchArchivedBlogs(currentPage, itemsPerPage)}
                className="px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600"
              >
                Retry
              </button>
            </div>
          )}

          {/* Empty State */}
          {!loading && !error && archivedPosts.length === 0 && (
            <div className="flex flex-col items-center justify-center py-16">
              <div className="text-6xl mb-4">📦</div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                No archived posts found
              </h3>
              <p className="text-gray-600">No archived posts to show.</p>
            </div>
          )}

          {/* Blog Posts Grid */}
          {!loading && !error && archivedPosts.length > 0 && (
            <>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-8">
                {archivedPosts.map((post) => (
                  <div
                    key={post.blog_id}
                    className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow cursor-pointer  border-2 border-yellow-200 relative"
                  >
                    {/* ARCHIVED Badge */}
                    <div className="p-2 bg-yellow-50 border-b border-yellow-100">
                      <span className="text-xs text-yellow-600 font-medium">
                        ARCHIVED
                      </span>
                    </div>

                    {/* Top-Right Post Menu Button */}
                    <div className="absolute top-12 right-3 z-10 post-menu">
                    <button
  onClick={() => togglePostMenu(post.blog_id)}
  className="p-2 bg-gray-100 hover:bg-gray-100 rounded-full transition-colors"
>
  <svg
    className="w-5 h-5 text-gray-500"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 5v.01M12 12v.01M12 19v.01"
    />
  </svg>
</button>

                      {/* Post Menu Dropdown */}
                      {openPostMenus[post.blog_id] && (
                        <div className="absolute top-full right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-50 overflow-hidden">
                          <div className="py-2">
                            <button
                              onClick={() =>
                                handlePostAction(
                                  "restore-to-active",
                                  post.blog_id
                                )
                              }
                              className="w-full text-left px-4 py-2 hover:bg-blue-50 transition-colors flex items-center text-blue-600"
                            >
                              <svg
                                className="w-4 h-4 mr-3"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                                />
                              </svg>
                              Restore
                            </button>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Card Image */}
                    <div className="h-50 bg-gradient-to-br from-purple-100 to-purple-200 flex items-center justify-center">
                      {post.main_image_url ? (
                        <img
                          src={post.main_image_url}
                          alt={post.title}
                          className="w-full h-[300px] min-h[300px] object-cover"
                        />
                      ) : (
                        <div className="w-16 h-16 bg-yellow-400 rounded-full flex items-center justify-center">
                          <svg
                            className="w-8 h-8 text-white"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                        </div>
                      )}
                    </div>

                    {/* Card Content */}
                    <div className="p-4">
                      <div className="flex justify-between items-start text-xs text-gray-600 mb-2">
                        <span>{post.status}</span>
                        <span>{formatDate(post.created_at)}</span>
                      </div>
                      <h3 className="font-semibold text-gray-800 mb-3 text-sm text-center">
                        {post.title}
                      </h3>
                      {post.tags && post.tags.length > 0 && (
                        <div className="flex flex-wrap gap-1 mt-2">
                          {post.tags.slice(0, 3).map((tag, index) => (
                            <span
                              key={index}
                              className="px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded"
                            >
                              {tag}
                            </span>
                          ))}
                          {post.tags.length > 3 && (
                            <span className="text-xs text-gray-500">
                              +{post.tags.length - 3} more
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="flex justify-center items-center gap-4 pb-16">
                  <button
                    onClick={goToPrevious}
                    disabled={currentPage === 1}
                    className="px-4 py-2 bg-white border border-gray-300 rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
                  >
                    Previous
                  </button>

                  <div className="flex gap-2">
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                      (page) => (
                        <button
                          key={page}
                          onClick={() => goToPage(page)}
                          className={`px-3 py-2 border rounded ${
                            currentPage === page
                              ? "bg-yellow-500 text-white border-yellow-500"
                              : "bg-white border-gray-300 hover:bg-gray-50"
                          }`}
                        >
                          {page}
                        </button>
                      )
                    )}
                  </div>

                  <button
                    onClick={goToNext}
                    disabled={currentPage === totalPages}
                    className="px-4 py-2 bg-white border border-gray-300 rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
                  >
                    Next
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default BlogArchive;
